
import API from '../config/api.js'

export const AuthService = {

    login(data) {
        // return API.post('/api/member/login', data);
        return API.post('/api/auth/token', data);
    },

    // login1(data) {
    //     // return API.post('/api/member/login1', data);
    //     return API.post('/api/auth/token', data);
    // },

    register(data) {
        return API.post('/api/member/create', data);
    },

    logout() {
        return API.post('/api/logout');
    },

    reset(data) {
        return API.post('/api/forgot-password', data);
    },

    getProfile() {
        return API.get('/api/user/profile');
    },

    updatePassword(data) {
        return API.patch(`api/member/password`, data);
    },

    getUserRoles() {
        return API.get(`api/user/roles`);
    },

    getMenuList(roleId) {
        return API.get(`api/menu/${roleId}`);
    },

    updateGoogleAuth(data) {
        return API.post(`api/update/googleAuth`, data);
    },
    getCompanySettings() {
        return API.get(`api/settings/get-company-settings`);
    },

    async login2FA(id, code, token) {
        const response = await API.post(`api/2fa/login`, { code, token, id })

        if (response.data.token) {
            localStorage.setItem('user', JSON.stringify(response.data.user))
            localStorage.setItem('token', response.data.token)
        }
        return response.data
    },

    async generate2FA(id) {
        return API.post(`api/user/${id}/2fa/setup`)
    },

    async verify2FA(id, code) {
        return API.post(`api/user/${id}/2fa/verify`, { code })
    }


}



